import React, { PropTypes } from 'react';
import { hashHistory } from 'react-router'
import DataService from '../lib/DataService';
import { Spin, message } from 'antd';

export default class LoginPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      code: props.location.query.code,
    };
  }

  componentDidMount() {
    DataService.getUserToken(this.state.code).then((res) => {
      document.location = "/web_app";
    }).catch((error) => {
      message.error('登录失败')
      hashHistory.push('/');
    });
  }

  render() {
    return (
      <Spin tip="正在登录中..." spinning={true}>
        <div className="pc-login-page">
          
        </div>
      </Spin>
      )
    }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/LoginPcApp/components/wxLoginPage.jsx